import { useState } from 'react';
import ExternalIdpGroups from './ExternalIdpGroups';
import ExternalIdpInfo from './ExternalIdpInfo';

const ExternalIdpStep = () => {
  const [idpInfoSaved, setIdpInfoSaved] = useState(false);
  const [metadataId, setMetadataId] = useState<string | null>(null);
  const [didVerifyDomain, setDidVerifyDomain] = useState(false);

  return idpInfoSaved ? (
    <ExternalIdpGroups metadataId={metadataId ?? ''} didVerifyDomain={didVerifyDomain} />
  ) : (
    <ExternalIdpInfo
      setIdpInfoSaved={setIdpInfoSaved}
      setMetadataId={setMetadataId}
      setDidVerifyDomain={setDidVerifyDomain}
    />
  );
};

export default ExternalIdpStep;
